/** Utilitários de cor para nós do fluxograma (tela + export PNG). */

/** Escurece misturando com preto (equiv. color-mix 60% cor + 40% preto). */
export function darkenForBorder(hex: string, amount = 0.4): string {
  const rgb = parseHex(hex)
  if (!rgb) return '#000000'
  const f = 1 - amount
  return toHex(
    Math.round(rgb.r * f),
    Math.round(rgb.g * f),
    Math.round(rgb.b * f),
  )
}

/** Alpha da cor sólida sobre fundo transparente (aprox. color-mix com transparent). */
export function colorWithAlpha(hex: string, alpha: number): string {
  const rgb = parseHex(hex)
  if (!rgb) return `rgba(0, 0, 0, ${alpha})`
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`
}

function parseHex(hex: string): { r: number; g: number; b: number } | null {
  const raw = hex.trim().replace(/^#/, '')
  if (/^[0-9a-fA-F]{3}$/.test(raw)) {
    return {
      r: parseInt(raw[0] + raw[0], 16),
      g: parseInt(raw[1] + raw[1], 16),
      b: parseInt(raw[2] + raw[2], 16),
    }
  }
  if (/^[0-9a-fA-F]{6}$/.test(raw)) {
    return {
      r: parseInt(raw.slice(0, 2), 16),
      g: parseInt(raw.slice(2, 4), 16),
      b: parseInt(raw.slice(4, 6), 16),
    }
  }
  return null
}

function toHex(r: number, g: number, b: number): string {
  const c = (n: number) =>
    Math.max(0, Math.min(255, n)).toString(16).padStart(2, '0')
  return `#${c(r)}${c(g)}${c(b)}`
}
